// 用户取，只有一个箱格
<template>
  <div class="openBoxOne back-index">
    <!-- 流程 -->
    <userFetchFlow :index="2"></userFetchFlow>
    <span
      class="status"
      :class="[box.showStatus ? 'success' : 'fail']"></span>
    <p class="info">{{box.showStatus ? box.box_size + '-' + box.box_number + '号箱格已打开' : box.message}}</p>
    <p
      class="des"
      v-if="box.showStatus">请取出物品并随手关门</p>
    <countDown v-if="beginCountDown"></countDown>
  </div>
</template>

<script>
import userFetchFlow from './userFetchFlow'
import countDown from '../common/countDown'
import { cabinetApi } from "../../../../static/turnoverCabinet/js/api.js"
import { showLoading, hideLoading, storage } from '../../../../static/turnoverCabinet/js/utility'
let vm

export default {
  name: 'openBoxOne',
  components: {
    userFetchFlow,
    countDown
  },
  data () {
    return {
      box: {},
      beginCountDown: false
    }
  },
  created () {
    vm = this
    console.log('this.box', this.box)
    // 取件码取件
    if (this.$route.query.passwordFetch) {
      this.updateBox(JSON.parse(this.$route.query.passwordFetch))
    } else if (JSON.parse(this.$route.query.boxList).length === 0) {
      // 当用户没有取件信息
      this.box = {
        showStatus: false,
        message: '暂时没有您的物件'
      }
      this.beginCountDown = true
    } else {
      this.box = JSON.parse(this.$route.query.boxList)[0]
      this.open()
    }
  },
  mounted () {
  },
  methods: {
    // 更新box
    updateBox (res) {
      vm.box.message = ''
      if (res.meta.code === 200) {
        vm.box = res.data.length !==0 ? res.data[0] : vm.box
        vm.box.showStatus = true
      } else {
        // vm.box.showStatus = false
        vm.box = {
          showStatus: false,
          message: res.meta.message
        }
      }
      console.log('box开箱', vm.box.message)
      vm.beginCountDown = true
    },
    // 取件
    open: async function () {
      let data = vm.$store.state.fetchData
      data.box_number = this.box.box_number
      data.device_no_id = storage.localGetItem('device_no_id')
      console.log('openbox', this.box)
      
      showLoading('正在打开箱格')
      let res = await cabinetApi.open(data)
      // console.log('res', res)
      hideLoading()
      vm.updateBox(res)
    },
  }
}
</script>

<style  scoped>
.openBoxOne{
  width: 100%;
  text-align: center;
}

.openBoxOne .status{
  display: block;
  width: 2rem;
  height: 2rem;
  margin: 0.8rem auto 0;
}

.openBoxOne .status.success{
  background: url(/../static/turnoverCabinet/images/icon/success.png) center no-repeat;
  background-size: 100%;
}

.openBoxOne .status.fail{
  background: url(/../static/turnoverCabinet/images/icon/fail.png) center no-repeat;
  background-size: 100%;
}

.openBoxOne .info{
  font-size: 0.45rem;
  line-height: 0.85rem;
  margin-top: 0.45rem;
}

.openBoxOne .info .num{
  font-weight: bold;
}

.openBoxOne .des{
  font-size: 0.3rem;
  line-height: 0.6rem;
}

</style>



// WEBPACK FOOTER //
// src/components/turnoverCabinet/userFetch/openBoxOne.vue